export const STORAGE_KEY: string = 'photo-bank'
